(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/pay-footer.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/pay-footer.js');
"use strict";

const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const {
  useState,
  useEffect
} = React;
setGlobal('svs.tickets.play.components.PlayFooter', _ref => {
  let {
    appTimeline,
    gamePayed,
    ticketInfo,
    handleGameDemo,
    handleGamePay,
    handleGift
  } = _ref;
  const {
    price
  } = ticketInfo;
  const [playerBalance, setPlayerBalance] = useState(0);
  const [remindReady, setRemindReady] = useState(false);
  const isTriss = svs.tickets.data.templateConfig.branding === 'triss';
  useEffect(() => {
    svs.components.account_balance.get(true, balance => {
      if (playerBalance !== balance) {
        setPlayerBalance(balance);
      }
    });
  }, [playerBalance, setPlayerBalance]);
  useEffect(() => {
    if (gamePayed) {
      gsap.to(document.querySelector('.payfooter'), 1, {
        y: '120%',
        ease: 'power4.out'
      });
    } else {
      gsap.to(document.querySelector('.payfooter'), 1, {
        y: '0',
        ease: 'power4.out'
      });
    }
  }, [gamePayed]);
  useEffect(() => {
    appTimeline.add(() => {
      setRemindReady(true);
    }, 'gameReady+=0.5');
  }, [appTimeline]);
  return React.createElement(Payfooter, {
    balance: playerBalance,
    buttons: [{
      pay: true,
      onClick: handleGamePay,
      className: 'qa-btn-pay',
      disabled: gamePayed
    }, {
      secondary: true,
      text: 'Ge bort',
      onClick: handleGift,
      visible: ticketInfo.isGiftable,
      disabled: gamePayed
    }, {
      secondary: true,
      text: 'Provspela',
      onClick: handleGameDemo,
      className: 'qa-btn-demo',
      disabled: gamePayed
    }, {
      link: true,
      text: 'Spelpaus24',
      className: 'js-pause24-trigger'
    }],
    hasReminder: remindReady && !gamePayed,
    reminderTrackingLabel: "".concat(isTriss ? 'Triss' : 'Skrapspel'),
    sum: price
  });
});

 })(window);